module.exports = __webpack_public_path__ + "media/rlsPhone.3377798b.mp4";